import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Fix 9: session is an httpOnly cookie set by the backend — send credentials, no JS token.
const api = axios.create({ baseURL: API, withCredentials: true });

export function fileUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
}

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Distinguishes a server we couldn't reach (network / CORS / offline) from a real API error.
export function errorMessage(err) {
  if (err && !err.response) {
    return "Can't reach the server. Please check your internet connection and try again.";
  }
  return apiError(err?.response?.data?.detail) || err?.message || "Something went wrong. Please try again.";
}

export default api;
